import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import RequestList from '../components/Requests/RequestList';
import EditRequest from '../components/Requests/EditRequest';


const Requests = () => {
  return (
    <Routes>
      <Route path="/" element={<RequestList />} />
      <Route path="/edit/:id" element={<EditRequest />} />
      <Route path="/edit" element={<EditRequest />} />
    </Routes>
  )
}

export default Requests;